/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acc_Type_BusinessInputs */

const en_acc_type_business = /** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const es_acc_type_business = /** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negocio`)
};

const fr_acc_type_business = /** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const de_acc_type_business = /** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

const id_acc_type_business = /** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisnis`)
};

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const ja_acc_type_business = en_acc_type_business;

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const zh_acc_type_business = en_acc_type_business;

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const ar_acc_type_business = en_acc_type_business;

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const it_acc_type_business = en_acc_type_business;

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const ru_acc_type_business = en_acc_type_business;

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const pt_acc_type_business = en_acc_type_business;

/** @type {(inputs: Acc_Type_BusinessInputs) => LocalizedString} */
const ko_acc_type_business = en_acc_type_business;

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Acc_Type_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acc_type_business = /** @type {((inputs?: Acc_Type_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acc_Type_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acc_type_business(inputs)
	if (locale === "es") return es_acc_type_business(inputs)
	if (locale === "fr") return fr_acc_type_business(inputs)
	if (locale === "de") return de_acc_type_business(inputs)
	if (locale === "ja") return ja_acc_type_business(inputs)
	if (locale === "zh") return zh_acc_type_business(inputs)
	if (locale === "ar") return ar_acc_type_business(inputs)
	if (locale === "id") return id_acc_type_business(inputs)
	if (locale === "it") return it_acc_type_business(inputs)
	if (locale === "ru") return ru_acc_type_business(inputs)
	if (locale === "pt") return pt_acc_type_business(inputs)
	return ko_acc_type_business(inputs)
});